// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const loginCenterEn = {
  pageTitle: "{platformName} Platform Admin Sign-in",
  eyebrow: "AIRange Control Plane",
  summary:
    "Platform workspaces first take over the current unified identity session, then enter the target control plane.",
  badgePlatform: "Platform Admin",
  badgeSso: "Unified Identity",
  badgeLocalFallback: "Local Account",
  badgeMaintenance: "Maintenance",
  badgeRunning: "Running",
  introEntryLabel: "Current Entry",
  introEntryValue: "Platform-layer Admin",
  introEntryHint:
    "This entry does not handle questions, papers, exams, or other business operations. It is only for platform governance capabilities.",
  introBoundaryLabel: "Access Boundary",
  introBoundaryValue: "Visible to platform admins",
  introBoundaryHint: "Platform roles are isolated from exam business roles.",
  credentialSection: "Credentials",
  authSource: "Sign-in Method",
  authSourceSso: "Unified Identity",
  authSourceLocal: "Local Login",
  ssoAlert:
    "This sign-in now uses the unified identity flow. The browser connects directly to sso-center without going through business API proxies.",
  usernamePlaceholder: "Enter username",
  passwordPlaceholder: "Enter password",
  captchaPlaceholder: "Enter captcha",
  usernameRequired: "Please enter username",
  passwordRequired: "Please enter password",
  captchaRequired: "Please enter captcha",
  submit: "Sign in to Platform Admin",
  footerPrimary: "Unified identity first",
  footerSecondary: "Local login is available for authorized operations.",
  maintenanceNotice:
    "The platform is in maintenance mode. Only authorized operators can access the platform admin.",
  noAccess: "This account does not have access to the platform admin.",
  mustChangePassword:
    "This account must change its password first. Please update it in the exam admin first.",
  captchaNeeded: "Captcha is required.",
  oidcCallbackProcessing: "Processing unified sign-in callback...",
  oidcCallbackMissingParams: "Unified sign-in callback is missing code/state parameters.",
  oidcCallbackFailed: "Failed to process unified sign-in callback.",
  oidcCallbackRuntimeConfigFailed: "Failed to read unified sign-in callback runtime configuration.",
  oidcCallbackRetryLogin: "Sign in again",
  oidcFailedNotice: "Unified sign-in callback failed. Please start sign-in again.",
} as const;
